<template>
	<div class="searchresult">
		<div class="search_resu">
			<div class="result_title">搜索内容【{{info.key}}】关联的帖子和评论结果
				<img class="iskeyword" :src="img.iskeyword" v-if="is_default==1">
				<img class="addkeyword" :src="img.addkeyword" v-if="is_default==0" @click="addKeyword()">
			</div>
			<div class="result_box">
				<van-row class="result_box_title">
					<van-col span="10">关联论坛</van-col>
					<van-col class="text-c" span="6">关联贴子数</van-col>
					<van-col class="text-c" span="4">评论数</van-col>
					<van-col class="text-c" span="4">操作</van-col>
				</van-row>
				<van-row v-for="(item,index) in info.bbs_arr" :key="'listb_' + index" :class="index % 2==0?'result_text result_text_active':'result_text'">
					<van-col style="text-decoration:underline;" span="10" @click="goBbsType(item.type)">{{item.name}}</van-col>
					<van-col class="text-c" span="6">{{item.number}}</van-col>
					<van-col class="text-c" span="4">{{item.comment_num_all}}</van-col>
					<van-col class="text-c" span="4" @click="goBbsType(item.type)">查看</van-col>
				</van-row>
			</div>
		</div>
		<div class="search_resu">
			<div class="result_title">趋势图表</div>
			<!-- <div class="home_title_info"><van-icon name="info-o" /></div> -->
			<div class="result_box">
				<div class="result_box_title">
					<div class="result_left">新增帖子趋势</div>
					<div class="result_right">帖子{{info.bbs_chart_num}}篇</div>
				</div>
				<div class="keyword_box">
					<div id="myChart" style="width: 95%;height:240px;margin-left: 12px;margin-top: 15px;"></div>
				</div>
			</div>
			<div class="result_box">
				<div class="result_box_title">
					<div class="result_left">新增评论趋势</div>
					<div class="result_right">评论{{info.comment_chart_num}}条</div>
				</div>
				<div class="keyword_box">
					<div id="myChartcom" style="width: 95%;height:240px;margin-left: 12px;margin-top: 15px;"></div>
				</div>
			</div>
		</div>
		<div class="search_resu">
			<div class="result_title">相关帖子</div>
			<van-pull-refresh v-model="isLoading" @refresh="onRefresh">
				<van-list
				v-model="loading"
				:finished="finished"
				finished-text="已加载全部"
				@load="onLoad"
				>
				
				<div class="result_box" v-for="item in bbs_list" :key="'list_' + item.id" @click="goBbs(item.id)">
					<div class="result_bbstit">{{item.name}}
						<img class="result_title_bage" v-if="item.label_two.type==2" :src="img.new">
						<img class="result_title_bage" v-if="item.label.type==1&&item.label.name=='1级'" :src="img.level1">
						<img class="result_title_bage" v-if="item.label.type==1&&item.label.name=='2级'" :src="img.level2">
						<img class="result_title_bage" v-if="item.label.type==1&&item.label.name=='3级'" :src="img.level3">
						<img class="result_title_bage" v-if="item.label.type==3" :src="img.hot">
						<img class="result_title_bage" v-if="item.label.type==4" :src="img.vie">
					</div>
					<div class="result_bbstime">
						<div style="flex: 1;">{{item.post_time}}</div>
						<div class="f-r">
							<span>阅读{{item.read_num}}</span>
							<span style="margin-left: 20px;">评论{{item.comment_num}}</span>
						</div>
					</div>
				</div>
			</van-list>
		</van-pull-refresh>
	</div>
</div>
</template>

<script>
	import admin from '../../api/admin';
	import { mapState } from 'vuex';
	import { Col, Row,Search,Cell,Toast,DatetimePicker,Field,Popup,Button,Icon,List,PullRefresh } from 'vant';
	export default {
		data () {
			return {
				search_input:true,
				message:'',
				text:'',
				maxDate:new Date(),
				currentDate: new Date(),
				showPicker:false,
				start_time:'',
				end_time:'',
				is_default:2,
				info:'',
				bbs_list:[],
				loading: false,
				finished: false,
				isLoading:false,
				
				img:{
					hot:require('../../assets/img/hot.png'),
					new: require('../../assets/img/new.png'),
					level1: require('../../assets/img/level1.png'),
					level2: require('../../assets/img/level2.png'),
					level3: require('../../assets/img/level3.png'),
					vie:require('../../assets/img/vie.png'),
					iskeyword: require('../../assets/img/iskeyword.png'),
					addkeyword: require('../../assets/img/addkeyword.png'),
				}
			}
		},
		computed: {
			...mapState({
				user: state => state.param.user
			})
		},
		mounted() {
			
		},
		created () {
			if(localStorage.getItem('searchParams')){
				this.params = JSON.parse(localStorage.getItem('searchParams'))
				this.btn_type=localStorage.getItem('btn_type')
				localStorage.removeItem('btn_type')
			}
			
		},
		methods: {
			// getAdminsearchnew(){
			// 	admin.getAdminsearchnew(this.params).then(res => {
			// 		if(res.data.state==1){
			// 			this.info=res.data.data
			// 			this.bbs_list=res.data.data.bbs_list
			// 			this.is_default=res.data.data.is_default
			// 			var bbs_chart_arr=res.data.data.bbs_chart_arr

			// 			var myChart = this.$echarts.init(document.getElementById('myChart'))
			// 			var series= [{
			// 				name: '关联帖子',
			// 				data:bbs_chart_arr.bbs_chart_info_number,
			// 				type: 'line',
			// 				smooth:true,
			// 				itemStyle: {
			// 					color: '#303231'
			// 				},
			// 			}]
			// 			myChart.setOption({
			// 				tooltip: {
			// 					trigger: 'axis'
			// 				},

			// 				xAxis: {
			// 					type: 'category',
			// 					boundaryGap: false,
			// 					data:bbs_chart_arr.bbs_chart_info_date
			// 				},
			// 				yAxis: {
			// 					type: 'value'
			// 				},
			// 				legend: {
			// 					data:['频次','关联帖子']
			// 				},
			// 				series:series
			// 			});
			// 			var comment_chart_arr=res.data.data.comment_chart_arr
			// 			var myChartcom = this.$echarts.init(document.getElementById('myChartcom'))
			// 			var series= [{
			// 				name: '关联评论',
			// 				data:comment_chart_arr.comment_chart_info_number,
			// 				type: 'line',
			// 				smooth:true,
			// 				itemStyle: {
			// 					color: '#303231'
			// 				},
			// 			}]
			// 			myChartcom.setOption({
			// 				tooltip: {
			// 					trigger: 'axis'
			// 				},

			// 				xAxis: {
			// 					type: 'category',
			// 					boundaryGap: false,
			// 					data: comment_chart_arr.comment_chart_info_date
			// 				},
			// 				yAxis: {
			// 					type: 'value'
			// 				},
			// 				legend: {
			// 					data:['频次','关联评论']
			// 				},
			// 				series:series
			// 			});
			// 			localStorage.removeItem('searchParams')
			// 		}else{
			// 		}

			// 	})
			// },

			addKeyword(){
				var parmas={
					content:this.info.key
				}
				admin.addKey(parmas).then(res => {
					if(res.data.state==1){
						this.is_default=2
					}else{

					}
				})
				
			},
			goBbs(id){
				localStorage.setItem('bbsid', id)
				wx.miniProgram.navigateTo({url:'/pages/webview/webview?scene=bbsinfo'})
			},
			goBbsType(type) {
				// var key=this.info.key
				// this.$router.push({name:'KeywordWarningInfo',params:{key:key,typeid:id}});
				localStorage.setItem('bbstype', type)
				localStorage.setItem('bbskey', this.info.key)
				localStorage.setItem('start_time', this.params.start_time)
				localStorage.setItem('end_time', this.params.end_time)
				localStorage.setItem('btn_type', this.btn_type)
				wx.miniProgram.navigateTo({url:'/pages/webview/webview?scene=keywordwarninginfo'})
			},
			onRefresh() {
				this.isLoading = false;
				this.finished = false
				this.list=[]
				this.params.page = 1
				this.onLoad()
			},
			onLoad(){
				setTimeout(() => {
					admin.getAdminsearchnew(this.params).then(res => {
						if(res.data.state==1){
							this.info=res.data.data
							// this.bbs_list=res.data.data.bbs_list
							this.is_default=res.data.data.is_default
							var bbs_chart_arr=res.data.data.bbs_chart_arr
							this.bbs_list.push.apply(this.bbs_list, res.data.data.bbs_list)
							
							this.params.page += 1
							this.loading = false

							if(res.data.data.bbs_list.length == 0) {
								this.finished = true
							}
							// var myChart = this.$echarts.init(document.getElementById('myChart'))
							// var series= [{
							// 	name: '关联帖子',
							// 	data:bbs_chart_arr.bbs_chart_info_number,
							// 	type: 'line',
							// 	smooth:true,
							// 	itemStyle: {
							// 		color: '#303231'
							// 	},
							// }]
							// myChart.setOption({
							// 	tooltip: {
							// 		trigger: 'axis'
							// 	},

							// 	xAxis: {
							// 		type: 'category',
							// 		boundaryGap: false,
							// 		data:bbs_chart_arr.bbs_chart_info_date
							// 	},
							// 	yAxis: {
							// 		type: 'value'
							// 	},
							// 	legend: {
							// 		data:['频次','关联帖子']
							// 	},
							// 	series:series
							// });
							// var comment_chart_arr=res.data.data.comment_chart_arr
							// var myChartcom = this.$echarts.init(document.getElementById('myChartcom'))
							// var series= [{
							// 	name: '关联评论',
							// 	data:comment_chart_arr.comment_chart_info_number,
							// 	type: 'line',
							// 	smooth:true,
							// 	itemStyle: {
							// 		color: '#303231'
							// 	},
							// }]
							// myChartcom.setOption({
							// 	tooltip: {
							// 		trigger: 'axis'
							// 	},

							// 	xAxis: {
							// 		type: 'category',
							// 		boundaryGap: false,
							// 		data: comment_chart_arr.comment_chart_info_date
							// 	},
							// 	yAxis: {
							// 		type: 'value'
							// 	},
							// 	legend: {
							// 		data:['频次','关联评论']
							// 	},
							// 	series:series
							// });
							localStorage.removeItem('searchParams')
						}else{
						}

					})
				}, 500);
			}
		},
		components: {
			[Col.name]: Col,
			[Row.name]: Row,
			[Search.name]:Search,
			[Cell.name]:Cell,
			[Toast.name]:Toast,
			[DatetimePicker.name]:DatetimePicker,
			[Field.name]:Field,
			[Popup.name]:Popup,
			[Button.name]:Button,
			[Icon.name]:Icon,
			[PullRefresh.name]:PullRefresh,
			[List.name]: List,
		}
	}
</script>
<style lang="scss">
.searchresult{
	padding: 15px;
	.result_title{
		font-size: 14px;
		margin-top: 15px;
		padding-bottom:10px;
		border-bottom: 1px solid #EEEEEE;
		display: flex;
		align-items: center;
		.iskeyword{
			width: 80px;
			height: 20px;
			margin-left: 5px;
		}
		.addkeyword{
			width: 94px;
			height: 20px;
			margin-left: 5px;
		}
		// .red_border{
		// 	border:1px solid #E02020;
		// 	color: #E02020;
		// 	font-size: 10px;
		// 	border-radius:4px;
		// 	padding:3px 10px;
		// 	margin-left: 5px;
		// }
		// .van-button{
		// 	height: auto;
		// 	color:#FFFFFF;
		// 	font-size: 10px;
		// 	border-radius:4px;
		// 	padding:3px 10px;
		// 	margin-left: 5px;
		// 	background-color:#333333;
		// }
	}
	.search_resu{
		margin-top: 20px;
		.result_box{
			font-size: 12px;
			padding:15px;
			margin-top: 15px;
			border:1px solid #BBBBBB;
			border-radius:4px;
			.result_box_title{
				display: flex;
				align-items:center;
				border-bottom:1px solid #EEEEEE;
				padding:0 10px 10px 10px;
				margin-bottom: 10px;
			}
			.result_text{
				display: flex;
				align-items:center;
				padding:10px 10px;
			}
			.result_text_active{
				background-color:#F8F8F8;
			}
			.result_left{
				flex: 1;
			}
			.result_right{
				float: right;
			}
			.result_bbstit{
				color: #333333;
				font-size: 12px;
				text-decoration:underline;
				border-bottom:1px solid #EEEEEE;
				padding-bottom:10px;
			}
			.result_title_bage{
				width: 36px;
				height: 16px;
				vertical-align:middle;
				margin-left: 10px;
			}
			.result_bbstime{
				color: #999999;
				font-size: 12px;
				padding-top:10px;
				display: flex;
				align-items:center;
			}
		}
		.keyword_box{
			border: 1px solid #BBBBBB;
			border-radius: 4px;
			font-size:12px;
		}
	}
}

</style>